<template>
	<JBox>
		<!-- Default slot -->
		<slot :openDialog="openDialog" :closeDialog="closeDialog" />

		<!-- Dialog modal -->
		<Portal :to="portalTo">
			<CModal :isVisible="isVisible">
				<JBox class="s-bg-white s-rounded-lg s-p-8">
					<slot name="content">
						<JHeadline class="s-text-2xl">{{ headline }}</JHeadline>
						<JText class="s-mb-2 s-text-gray-600">{{ description }}</JText>
					</slot>
					<slot name="actions">
						<!-- Relaxed mode - it is not required to type a phrase -->
						<JFlex class="s-justify-between s-mt-10" v-if="mode === 'relaxed'">
							<JButton v-if="cancelButton" :variant="cancelButtonVariant" @click="onCancel">{{ cancelButton }}</JButton>
							<JButton v-if="confirmButton" :variant="confirmButtonVariant" @click="onConfirm">{{ confirmButton }}</JButton>
						</JFlex>

						<!-- Strict mode - it is requireed to type a phrase -->
						<JBox class="s-justify-between s-mt-10" v-if="mode === 'strict'">
							<JInputText v-model="keywordToMatch" :placeholder="strictModeLabel" />
							<JFlex class="s-justify-between s-mt-10">
								<JButton v-if="cancelButton" :variant="cancelButtonVariant" @click="onCancel">{{ cancelButton }}</JButton>
								<JButton v-if="confirmButton && keywordToMatch === keyword" :variant="confirmButtonVariant" @click="onConfirm">
									{{ confirmButton }}
								</JButton>
							</JFlex>
						</JBox>
					</slot>
				</JBox>
			</CModal>
		</Portal>
	</JBox>
</template>

<script>
export default {
	props: {
		mode: {
			// When strict, it is required to type a keyword or it is not possible to proceed
			type: String,
			validator(val) {
				return ["strict", "relaxed"].includes(val)
			},
			default: () => `relaxed`
		},
		strictModeLabel: {
			type: String,
			default: () => ``
		},
		keyword: {
			// What has to be typed to be possible to proceed
			type: String,
			default: () => ``
		},

		headline: {
			type: String
		},
		description: {
			type: String
		},
		cancelButton: {
			type: String
		},
		cancelButtonVariant: {
			type: String,
			default: () => `white`
		},
		confirmButton: {
			type: String
		},
		confirmButtonVariant: {
			type: String,
			default: () => `error-light`
		},
		portalTo: {
			type: String,
			default: () => `layer5`
		}
	},

	data() {
		return {
			isVisible: false,
			keywordToMatch: ""
		}
	},

	methods: {
		onConfirm() {
			this.isVisible = false
			this.$emit("confirm")
		},

		onCancel() {
			this.isVisible = false
			this.$emit("cancel")
		},

		openDialog() {
			this.isVisible = true
		},

		closeDialog() {
			this.isVisible = false
		}
	}
}
</script>
